import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router'
import { useAuthStore } from '@/modules/auth'

export function setupRouteGuards(router: Router): void {
  router.beforeEach(
    (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
      const authStore = useAuthStore()

      if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        next({ name: 'login', query: { redirect: to.fullPath } })
        return
      }

      if (to.meta.requiresAdmin && !authStore.isAdmin) {
        next({ name: 'home' })
        return
      }

      if (to.meta.guest && authStore.isAuthenticated) {
        next({ name: 'home' })
        return
      }

      next()
    }
  )
}
